export default "__VITE_ASSET__BzhEMiIZ__"